import { getAccessToken, isDemoSession } from '@/auth/oidc'
import type { DataSourceKind } from './domain'

/**
 * Demo fixture chrome only when the operator chose demo login.
 * A Keycloak access token always means live API paths — never the Mock chip.
 */
export function resolveDataSource(demo = isDemoSession()): DataSourceKind {
  if (getAccessToken()) return 'live'
  return demo ? 'mock' : 'live'
}

export function dataSourceLabel(kind: DataSourceKind): string {
  return kind === 'mock' ? 'Mock data' : 'Live'
}
